var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationStatus = function SvgNotificationStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "notification-status_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notification-status_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.998 21.692q-.746 0-1.276-.53a1.74 1.74 0 0 1-.53-1.277h3.616q0 .747-.532 1.277-.531.53-1.278.53M4.5 18.884v-1.5h1.808V9.924q0-2.017 1.245-3.567a5.52 5.52 0 0 1 3.197-1.983V3.75q0-.52.364-.885Q11.48 2.5 12 2.5t.885.365.366.885v.2a5 5 0 0 0-.39.904 4 4 0 0 0-.177.954 9 9 0 0 0-.333-.054A2.5 2.5 0 0 0 12 5.73q-1.737 0-2.964 1.228-1.228 1.227-1.228 2.964v7.462h8.384v-6.252q.345.123.727.192.383.069.773.06v6H19.5v1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA4F25",
    d: "M14.803 8.698a2.65 2.65 0 0 0 1.948.802q1.146 0 1.947-.803a2.65 2.65 0 0 0 .802-1.948q0-1.146-.803-1.947A2.65 2.65 0 0 0 16.749 4q-1.146 0-1.947.803A2.66 2.66 0 0 0 14 6.75q0 1.146.803 1.947"
  }))));
};
export default SvgNotificationStatus;